import React from 'react';

export function CircularProgressSmall(props) {
    return (
        <div style={{overflow: 'visible', transform: 'scale(0.5,0.5)', height: '0', width: '40px'}}>
            <div className="preloader-wrapper active">
                <div className={"spinner-layer spinner-" + (props.color || 'primary') + "-only"}>
                    <div className="circle-clipper left">
                        <div className="circle"></div>
                    </div><div className="gap-patch">
                        <div className="circle"></div>
                    </div><div className="circle-clipper right">
                        <div className="circle"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function CircularProgress(props) {
    return (
        <div style={{overflow: 'hidden'}}>
            <div className="preloader-wrapper active">
                <div className={"spinner-layer spinner-" + (props.color || 'primary') + "-only"}>
                    <div className="circle-clipper left">
                        <div className="circle"></div>
                    </div><div className="gap-patch">
                        <div className="circle"></div>
                    </div><div className="circle-clipper right">
                        <div className="circle"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}